import * as React from 'react';
import { useMemo } from 'react';

import { GdsService_OrderAdditionalServiceGdsServiceMisc_Fragment as MiscServiceFragment } from '@websky/graphql';
import { CartServiceProps } from '../types';
import { CheckoutSteps } from '../../MobileStepbar/types';
import { ServiceSummary } from '../../features/service-summary';
import CartItemOptionAdapter, { CartGroupOptionAdapterType } from '../CartItemOptionAdapter/CartItemOptionAdapter';
import ServiceSummaryDivider from '../../ServiceSummary/components/ServiceSummaryDivider/ServiceSummaryDivider';
import CartServiceSummary from '../../ServiceSummary';

const Misc: React.FC<CartServiceProps> = ({ services, onServiceDelete, renderService }) => {
	const gdsServices = useMemo(() => {
		return new Map(services.gdsServices?.services?.map(service => [service.id, service]) || []);
	}, [services?.gdsServices]);

	return (
		<ServiceSummary
			serviceType="Misc"
			onDelete={onServiceDelete}
			renderSummary={groups => {
				const miscGroupsPerSubType = new Map<string, CartGroupOptionAdapterType[]>();

				for (const group of groups) {
					for (const item of group.items) {
						const miscService = gdsServices.get(item.id) as MiscServiceFragment;

						if (!miscService) {
							continue;
						}

						const rfisc = miscService.rfisc;
						miscGroupsPerSubType.set(rfisc, [
							...(miscGroupsPerSubType.get(rfisc) ?? []),
							{
								...group,
								items: group.items.filter(item => !item.rfisc || item.rfisc === rfisc)
							}
						]);
					}
				}

				return (
					<>
						{[...miscGroupsPerSubType].map(([subType, groups]) => {
							const header = groups[0]?.items?.[0]?.name;
							const cartGroup = { header };

							const content = (
								<ServiceSummaryDivider>
									{groups.map((group, index) => (
										<CartItemOptionAdapter key={`${subType}-${index}`} option={group} />
									))}
								</ServiceSummaryDivider>
							);

							return (
								renderService?.(CheckoutSteps.Extras, cartGroup, content) ?? (
									<CartServiceSummary key={subType} group={cartGroup}>
										{content}
									</CartServiceSummary>
								)
							);
						})}
					</>
				);
			}}
		/>
	);
};

export default Misc;
